<template>
  <div class="add-fragment">
    <label>
      <span class="add-fragment__label">Фрагмент:</span>
      <select
        class="add-fragment__select"
        v-model="selectedFragmentId"
      >
        <option
          disabled
          selected
          v-bind:value="$options.emptyFragmentId"
        >Выберите фрагмент</option>
        <optgroup
          v-for="group in groupedFragmentTypes"
          v-bind:key="group.title"
          v-bind:label="group.title"
        >
          <option
            v-for="fragment in group.items"
            v-bind:key="fragment.id"
            v-bind:value="fragment.id"
          >{{ fragment.name }}</option>
        </optgroup>
      </select>
    </label>
    <button
      class="add-fragment__add"
      type="button"
      v-on:click="onAdd"
    >Добавить</button>
  </div>
</template>
<script>
import notifierMixin from '@/mixins/notifierMixin';

/**
 * @description Добавление фрагмента формы создания шаблона СМС.
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Группированные типы фрагментов шаблона.
     * @returns {{title: string, items: any[]}[]}
     */
    groupedFragmentTypes() {
      return Object
        .entries(
          this
            .types
            .reduce((acc, item) => {
              const groupName = item.group || 'Прочие';
              if (Object.prototype.hasOwnProperty.call(acc, groupName) !== true) {
                acc[groupName] = [];
              }
              acc[groupName].push(item);
              return acc;
            }, {}),
        )
        .map(([title, items]) => ({ title, items }))
        .sort((left, right) => (left.title > right.title ? 1 : 0));
    },
    /**
     * @description Выбранный фрагмент шаблона.
     * @returns {any|undefined}
     */
    selectedFragment() {
      return this.types.find(({ id }) => this.selectedFragmentId === id);
    },
  },
  data() {
    return {
      /**
       * @description Идентификатор выбранного фрагмента.
       * @type {string}
       */
      selectedFragmentId: this.$options.emptyFragmentId,
    };
  },
  /**
   * @description Пустой идентификатор фрагмента.
   * @type {string}
   */
  emptyFragmentId: '',
  methods: {
    /**
     * @description Обработать добавление фрагмента.
     * @returns {void}
     */
    onAdd() {
      if (this.selectedFragment) {
        this.$emit('input', this.selectedFragment);
        this.reset();
      } else {
        this.notifyFail('Выберите тип добавляемого фрагмента');
      }
    },
    /**
     * @description Сбросить выбранный фрагмент.
     * @returns {void}
     */
    reset() {
      this.selectedFragmentId = this.$options.emptyFragmentId;
    },
  },
  mixins: [
    notifierMixin,
  ],
  name: 'NotificationPlanAddFragment',
  props: {
    /**
     * @description Фрагменты.
     * @type {any[]}
     */
    types: { required: true, type: Array },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";
.add-fragment {
  background-color: var(--fill-color);
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  &__add {
    @include buttons.btn-transparent-add(1rem);
    color: var(--action-color);
  }
  &__label ~ &__select {
    margin-left: 1rem;
  }
  &__select {
    background-color: var(--primary-background-color);
    border: 1px solid var(--border-color);
    border-radius: var(--input-border-radius);
    padding: .3rem .5rem;
  }
}
</style>
